(() => {
  function enhanceDetails(root = document) {
    root.querySelectorAll('[data-dekuch-details]').forEach((details) => {
      if (details.dataset.enhanced) return;
      details.dataset.enhanced = 'true';
      const overview = details.querySelector('[data-dekuch-overview]');
      const specs = details.querySelector('[data-dekuch-specs]');
      const packages = details.querySelector('[data-dekuch-package]');
      function groupContainer(source, target) {
        const parent = source.closest('details');
        const summary = parent?.querySelector(':scope > summary')?.textContent.trim();
        const sku = summary?.match(/^([A-Z0-9_\-]{5,})\s*(?:—| - )/i)?.[1];
        if (!sku) return target;
        const group = document.createElement('div');
        group.dataset.dekuchVariantDetails = sku;
        const label = document.createElement('h4');
        label.textContent = summary;
        group.appendChild(label);
        target.appendChild(group);
        return group;
      }
      function moveGroup(heading, target) {
        const nodes = [heading];
        let next = heading.nextElementSibling;
        while (next && !/^H[1-6]$/.test(next.tagName)) {
          nodes.push(next);
          next = next.nextElementSibling;
        }
        if (nodes.length < 2) return;
        const group = groupContainer(heading, target);
        nodes.forEach((node) => group.appendChild(node));
      }
      // Move verified comparison-row data into per-SKU sections.
      overview.querySelectorAll('table').forEach((table) => {
        const rows = Array.from(table.rows);
        const headers = Array.from(rows[0]?.cells || []).map(c => c.textContent.trim().toLowerCase());
        if (headers[0] !== 'sku' || !headers.includes('specifications')) return;
        const specIndex = headers.indexOf('specifications');
        const packageIndex = headers.indexOf('package contents');
        rows.slice(1).forEach(row => {
          const sku = row.cells[0]?.textContent.trim();
          const text = row.cells[specIndex]?.textContent.trim();
          if (!sku || !text) return;
          const source = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = sku + ' - ' + (row.cells[1]?.textContent.trim() || 'Configuration');
          source.appendChild(summary);
          const heading = document.createElement('h3'); heading.textContent = 'Specifications'; source.appendChild(heading);
          const specTable = document.createElement('table');
          text.split(';').filter(x => x.trim()).forEach(item => {
            const tr = specTable.insertRow(); const colon = item.indexOf(':');
            const th = document.createElement('th'); th.textContent = colon >= 0 ? item.slice(0,colon).trim() : 'Details'; tr.appendChild(th);
            const td = tr.insertCell(); td.textContent = colon >= 0 ? item.slice(colon+1).trim() : item.trim();
          });
          source.appendChild(specTable);
          const packageText = packageIndex >= 0 ? row.cells[packageIndex]?.textContent.trim() : '';
          if (packageText) { const h = document.createElement('h3'); h.textContent = 'Package contents'; source.appendChild(h); const p = document.createElement('p'); p.textContent = packageText; source.appendChild(p); }
          overview.appendChild(source);
        });
        const parent = table.parentElement;
        table.remove(); if (parent && !parent.textContent.trim() && parent !== overview) parent.remove();
      });
      overview.querySelectorAll('details li').forEach(li => {
        if (!/^(?:What.?s in the Package|Package Contents|Professional Accessories)\s*:/i.test(li.textContent.trim())) return;
        const source = li.closest('details');
        const heading = document.createElement('h3'); heading.textContent = 'Package contents'; source.appendChild(heading);
        const list = document.createElement('ul'); list.appendChild(li); source.appendChild(list);
      });
      Array.from(overview.querySelectorAll('h2,h3,h4')).forEach((heading) => {
        if (!overview.contains(heading)) return;
        const text = heading.textContent.trim();
        if (/^(?:package(?: contents| includes| information)?|what.?s included|in the box|packing list)\s*:?$/i.test(text)) moveGroup(heading, packages);
        else if (/^(?:specifications?|technical (?:details|specifications))\s*:?$/i.test(text)) moveGroup(heading, specs);
      });
      overview.querySelectorAll('table').forEach((table) => {
        groupContainer(table, specs).appendChild(table);
      });
      overview.querySelectorAll('details').forEach(node => { if (node.children.length === 1 && node.firstElementChild.tagName === 'SUMMARY') node.remove(); });
      overview.querySelectorAll('h2').forEach(node => { if (/^(Compare exact SKUs|Details by SKU)$/i.test(node.textContent.trim())) node.remove(); });
      const syncSelected = () => {
        const sku = details.closest('product-info')?.querySelector('[data-dekuch-sku]')?.dataset.dekuchSku;
        details.querySelectorAll('[data-dekuch-variant-details]').forEach((group) => {
          group.hidden = Boolean(sku && group.dataset.dekuchVariantDetails !== sku);
        });
        [specs, packages].forEach((target) => {
          const fallback = target.querySelector('[data-dekuch-fallback]');
          const confirmed = Array.from(target.querySelectorAll('[data-dekuch-variant-details]')).some((group) => !group.hidden);
          const general = Array.from(target.children).some(node => node !== fallback && !node.hasAttribute('data-dekuch-variant-details') && node.textContent.trim());
          if (fallback) fallback.hidden = confirmed || general;
        });
      };
      syncSelected();
      if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, syncSelected);
      details.querySelectorAll('table').forEach((table) => {
        if (table.parentElement.classList.contains('dekuch-table-scroll')) return;
        const scroll = document.createElement('div');
        scroll.className = 'dekuch-table-scroll';
        scroll.tabIndex = 0;
        scroll.setAttribute('role', 'region');
        scroll.setAttribute('aria-label', specs.closest('details').querySelector('summary').textContent.trim());
        table.before(scroll);
        scroll.appendChild(table);
      });
      details.querySelectorAll('.rte [style]').forEach((node) => {
        if (!node.closest('table') && !['IMG', 'VIDEO'].includes(node.tagName)) {
          node.style.maxWidth = '100%';
          node.style.minWidth = '0';
        }
      });
    });
  }
  function enhanceBuybar(root = document) {
    root.querySelectorAll('[data-dekuch-buybar]').forEach((bar) => {
      if (bar.dataset.enhanced) return;
      bar.dataset.enhanced = 'true';
      const productInfo = bar.closest('product-info');
      const button = bar.querySelector('[data-dekuch-buybar-button]');
      const nativeButton = () => productInfo?.querySelector('.product-form__submit');
      const sync = () => {
        const native = nativeButton();
        if (!native) { bar.hidden = true; return; }
        const variantId = productInfo.querySelector('form input[name="id"]')?.value;
        const choosing = !variantId;
        const label = choosing ? bar.dataset.chooseLabel : (native.querySelector('span')?.textContent.trim() || native.textContent.trim());
        if (button.textContent !== label) button.textContent = label;
        const disabled = !choosing && native.disabled;
        if (button.disabled !== disabled) button.disabled = disabled;
        bar.hidden = Boolean(document.querySelector('cart-drawer.active, details[open] .menu-drawer, details[open] .search-modal'));
      };
      button.addEventListener('click', () => {
        const native = nativeButton();
        if (!productInfo.querySelector('form input[name="id"]')?.value) {
          const picker = productInfo.querySelector('variant-selects');
          picker?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          picker?.querySelector('select,input')?.focus({ preventScroll: true });
        } else if (native && !native.disabled) native.click();
      });
      const observer = new MutationObserver(sync);
      observer.observe(productInfo, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      document.querySelectorAll('cart-drawer,header details').forEach((node) => {
        new MutationObserver(sync).observe(node, { attributes: true, attributeFilter: ['class', 'open'] });
      });
      sync();
    });
  }
  const init = () => { enhanceDetails(); enhanceBuybar(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
